export default __webpack_public_path__ + "static/media/Product-Id.28f2f658.jpg";